import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";
import { TypographyScale } from "../../../../Foundation/Typography/Typography.styles";

export const _AboutPetitPrinceRoot = styled("div")(
  () => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 642px;
    gap: 40px;

    @media ${responsiveMap.mobile} {
      width: 100%;
      gap: 52px;
    }

    .about-petit-prince__logo {
      width: 100%;
      max-width: 280px;

      @media ${responsiveMap.mobile} {
        max-width: 182px;
        margin: 0 auto;
      }

      img {
        width: 100%;
        height: auto;
      }
    }

    .about-petit-prince__description {
      width: 100%;
    }
  `
);
